type EventType = "beforeunload" | "unload" | "visibilitychange" | "pagehide";
type EventsType = EventType[];

export class OnUnloadCaller {
  constructor(callback: () => void, events?: EventsType) {
    this.callback = callback;
    this.subscribed = false;
    this.events = events || [
      "beforeunload",
      "unload",
      "visibilitychange",
      "pagehide",
    ];
  }

  callback: () => void;

  events: EventsType;

  subscribed: boolean;

  public subscribe() {
    if (this.subscribed) return;
    this.subscribed = true;
    this.events.forEach(event => {
      if (event === "visibilitychange") {
        document.addEventListener(event, this.handleVisibilityChange);
      } else {
        window.addEventListener(event, this.handleUnload);
      }
    });
  }

  public unsubscribe() {
    if (!this.subscribed) return;
    this.subscribed = false;
    this.events.forEach(event => {
      if (event === "visibilitychange") {
        document.removeEventListener(event, this.handleVisibilityChange);
      } else {
        window.removeEventListener(event, this.handleUnload);
      }
    });
  }

  private handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      this.handleUnload();
    }
  };

  private handleUnload = () => {
    this.callback();
    this.unsubscribe(); // Отписываемся после первого вызова handleUnload
  };
}
